import { createFileRoute } from "@tanstack/react-router";

import { datasourcesTabSearchSchema } from "@/features/datasource/lib/data-resource-search";
import { getDatasourceFiltersOptions } from "@/openapi/@tanstack/react-query.gen";

export const Route = createFileRoute("/_protected/data/datasources")({
  validateSearch: datasourcesTabSearchSchema,
  loader: ({ context: { queryClient, ...context } }) => {
    const orgId = context.user.organization?.id;
    if (!orgId) {
      throw new Error("Organization ID not found");
    }

    void queryClient.query({
      ...getDatasourceFiltersOptions({
        path: {
          org_id: orgId,
        },
      }),
      staleTime: "static",
    });
  },
});
